import { render, staticRenderFns } from "./MceEditor.vue?vue&type=template&id=66364d7c&scoped=true&"
import script from "./MceEditor.vue?vue&type=script&lang=js&"
export * from "./MceEditor.vue?vue&type=script&lang=js&"
import style0 from "./MceEditor.vue?vue&type=style&index=0&id=66364d7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66364d7c",
  null
  
)

export default component.exports